import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { openReactConfirmationDialog } from '~commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '~src/codegen/Localize';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import {
  DeletePublishedConnectionDraftReduxAction
} from '~src/publishedConnection/actions/DeletePublishedConnectionDraftReduxAction';
import { PublishedConnections } from '~src/publishedConnection/resources/PublishedConnections';
import { reloadSpace } from '~src/spacesPlatform/sagas/content/RefreshContentSagas';

export function* handleDeletePublishedConnectionDraft(action: DeletePublishedConnectionDraftReduxAction): SagaIterator {
  try {
    yield call(openDialog, action.draftLuid);
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function openDialog(draftLuid: string) {
  const confirmationDialog = openReactConfirmationDialog<string, IResult>({
    title: Messages.deletePublishedConnectionDraftConfirmTitle(),
    message: Messages.deletePublishedConnectionDraftConfirmMessage(),
    actionName: Messages.deleteDraft(),
    action: PublishedConnections.deletePublishedConnectionDraft,
    paramsForAction: draftLuid,
    isActionDelete: true,
    dialogWidth: TabDialogWidth.width375px
  });

  confirmationDialog.result.then((result: IResult) => {
    PublishedConnections.toast(result,
      Messages.deletePublishedConnectionDraftSuccess(),
      Messages.deletePublishedConnectionDraftError()
    );
    return result;
  }, () => {
    // don't do anything
  });
  return confirmationDialog.result;
}
